import "./App.css";
import Body from "./Body";
import Footer from "./Footer";
import logoDesc from "./images/LogoDescriptionColour.png";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="row justify-content-between">
          <div className="col-md-4 text-center">
            <img
              src={logoDesc}
              className="App-logo-desc rounded"
              style={{ width: "100%" }}
              alt="Logo Description"
            />
          </div>
          <div className="col-md-8 text-center">
            <h1 className="mt-5">Nyasha Tavatya</h1>
            <h2>Full Stack Developer, Manchester, UK</h2>
          </div>
        </div>
      </header>
      <Body />
      <Footer />
    </div>
  );
}

export default App;
